module.exports = __webpack_public_path__ + "static/media/techtomedix-logo.6dcb3144.png";